var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-submenu',{class:_vm.cssClass,attrs:{"index":_vm.item.index}},[_c('template',{slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.item.sectionName)))])]),_vm._v(" "),_vm._l((_vm.filteredItems(_vm.item.subItems)),function(subItem){return [_c('nav-item',{key:subItem.index,attrs:{"item":subItem,"css-class":"level3"}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7399188","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/navigation/LeftNavigationSubMenu.vue
// module id = null
// module chunks = 